import './App.css';
import ReduxProvider from './redux/provider';
import Search from './search/index';
import SearchBar from './search/searchBar';
import { createPortal } from 'react-dom';
import RelatedContent from './search/relatedContent';
import PublicSearch from './search/publicSearch';
import HeaderSearchBar from './search/HeaderSearchBar';

const searchResultsWrapper = document.getElementById('search-results-wrap');
const searchBarWrapper = document.getElementById('search-bar');
const relatedContentWrapper = document.getElementById('related-content');
const publicSearchResultsWrapper = document.getElementById('public-search-results-wrap');
const headerSearchWrapper = document.getElementById('header-search-portal');

function App() {
    return (
        <ReduxProvider>
            <>
                {headerSearchWrapper && createPortal(<HeaderSearchBar />, headerSearchWrapper)}
                {searchBarWrapper && createPortal(<SearchBar />, searchBarWrapper)}

                {searchResultsWrapper && createPortal(<Search />, searchResultsWrapper)}
                {relatedContentWrapper && createPortal(<RelatedContent />, relatedContentWrapper)}
                {publicSearchResultsWrapper &&
                    createPortal(<PublicSearch />, publicSearchResultsWrapper)}
                {/* related items */}
            </>
        </ReduxProvider>
    );
}

export default App;
